import { Chip, SvgIconNames } from '@toggle/design-system';
import React from 'react';

import type { SeriesType } from '~/types/series.types';

export interface ChartTypeSelectorProps {
  selectedSeriesType: SeriesType;
  onChange: (chartType: SeriesType) => void;
}

const availableCharts: SeriesType[] = ['line', 'candlestick', 'bars'];

const chartTypeToIconName: Record<SeriesType, SvgIconNames> = {
  bars: 'Bars',
  candlestick: 'Candlestick',
  line: 'Line',
};

export const ChartTypeSelector = ({
  selectedSeriesType,
  onChange,
}: ChartTypeSelectorProps) => {
  return (
    <>
      {availableCharts.map(chartType => (
        <Chip
          key={chartType}
          type="choice"
          leftIcon={chartTypeToIconName[chartType]}
          isActive={chartType === selectedSeriesType}
          onClick={() => onChange(chartType)}
        />
      ))}
    </>
  );
};
